<template>
  <n-form-item
    :label="label"
    :label-style="labelStyle"
    :path="path"
    class="flex-1"
    :rule="rule"
  >
    <template v-slot:label>
      <span class="mr-1">
        {{ label }}
      </span>
      <help-text v-if="help"> {{ help }}</help-text>
    </template>
    <n-time-picker
      v-bind="$attrs"
      style="width: 100%"
      clearable
      @update:value="$emit('input', input)"
      :type="type"
      v-model:value="input"
      @keydown.enter.prevent
    >
    </n-time-picker>
  </n-form-item>
</template>

<script>
import { getSettings } from "../../../assets/js/common.helper";
import HelpText from "../HelpText.vue";

export default {
  components: { HelpText },
  inheritAttrs: false,
  props: {
    help: { type: String, default: "" },
    value: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: "date",
    },
    path: {},
    customRules: {
      type: Array,
      default: () => [],
    },
    rules: {
      type: Array,
      default: () => [],
    },
    label: { type: String, default: "" },
    settings: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      input: null,
    };
  },
  computed: {
    unit() {
      let settings = getSettings({ ...this.field });
      return settings.unit;
    },
    rule() {
      let { rules } = this;
      const vm = this;
      let settings = this.settings || {};
      return {
        trigger: ["submit", "blur", "input"],
        required: settings.is_required || false,
        validator() {
          for (let rule of rules) {
            let msg = rule({ v: vm.input, ...vm.settings });
            if (msg) return new Error(msg);
          }
        },
      };
    },
  },
  watch: {
    input(val) {
      this.input = val || null;
    },
  },
  mounted() {
    this.input = this.value || null;
  },
};
</script>

<style>
</style>